<template>
  <div class="footer">
    <div class="footer-main clearfix">
      <div class="footer-menu fl clearfix">
        <div class="menu-item fl" v-for="(item, index) in list" :style="{ width: index==0 ? 110 + 'px' : 130 + 'px' }">
          <div class="menu-title">
            <router-link :to="item.url">{{item.title}}</router-link>
          </div>
          <div class="menu-detail" v-for="it in item.listDetail">
            <router-link :to="it.url">{{it.title}}</router-link>
          </div>
        </div>
        <div class="menu-address fl">
          <div class="menu-title">公司地址</div>
          <div class="menu-address-detail">上海市浦东新区陆家嘴环路
            <br />166号未来资产大厦16C</div>
          <div class="menu-address-detail">北京市东城区东直门外大街
            <br />48号东方银座15M</div>
        </div>
      </div>
      <div class="footer-info fl">
        <div class="footer-info-box">
          <img src="../assets/images/index/ewm.png" />
          <p>更多详情请关注二维码</p>
        </div>
        <div class="footer-info-list">
          <div class="footer-info-number">咨询热线：</div>
          <div class="footer-info-number">021-5080-9106
            <span>（上海）</span>
          </div>
          <div class="footer-info-number">010-8418-5896
            <span>（北京）</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copy">
      <div class="footer-copy-main">华振公司版权所有 京ICP备18022072号-1</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data() {
      return {
        list: [{
          title: "首页",
          url: "/",
          listDetail: [{
            title: "首页",
            url: "/"
          }]
        }, {
          title: "走进华振",
          url: "/introduce",
          listDetail: [{
            title: "公司简介",
            url: "/introduce?part=1"
          }, {
            title: "管理团队",
            url: "/introduce?part=2"
          }, {
            title: "愿景与使命",
            url: "/introduce?part=3"
          }]
        }, {
          title: "我们的服务",
          url: "/service",
          listDetail: [{
            title: "投融资咨询",
            url: "/service?type=supplychain"
          }, {
            title: "海外资产配置咨询",
            url: "/service?type=finance"
          }, {
            title: "企业战略咨询",
            url: "/service?type=familyoffice"
          }, {
            title: "ABBC实验室",
            url: "/service?type=ABBClab"
          }]
        }, {
          title: "华振动态",
          url: "/news",
          listDetail: [{
            title: "公司新闻",
            url: "/news?type=company"
          }, {
            title: "主题论坛",
            url: "/news?type=themeforum"
          }, {
            title: "公益慈善",
            url: "/news?type=charity"
          }, {
            title: "员工活动",
            url: "/news?type=employee"
          }]
        }]
      }
    },
    methods: {

    }
  }
</script>

<style scoped>
  .footer {
    background: #333;
    color: #fff;
  }

  .footer-main {
    padding: 40px 30px 20px;
    margin: 0px auto;
    width: 1200px;
    background: #333;
    box-sizing: border-box;
  }

  .footer-menu {}

  .menu-item {
    font-size: 10px;
    color: #d7d7d7;
  }

  .menu-title {
    margin-bottom: 4px;
    font-size: 12px;
    color: #fff;
    line-height: 24px;
  }

  .menu-detail {
    font-size: 10px;
    color: #d7d7d7;
    line-height: 24px;
  }

  .menu-address {
    margin-right: 240px;
    width: 158px;
    font-size: 10px;
    color: #d7d7d7;
  }

  .menu-address-detail {
    margin-bottom: 7px;
    font-size: 10px;
    color: #d7d7d7;
    line-height: 24px;
  }

  .footer-info {}

  .footer-info-box {
    margin-top: 8px;
    width: 146px;
    font-size: 12px;
  }

  .footer-info-box img {
    width: 100px;
  }

  .footer-info-box p {
    margin-top: 10px;
    color: #d7d7d7;
    font-size: 10px;
  }

  .footer-info-list {
    margin-top: 20px;
    font-size: 12px;
    line-height: 24px;
  }

  .footer-info-number {
    font-size: 12px;
    line-height: 24px;
  }

  .footer-info-number span {
    color: #d7d7d7;
    font-size: 10px;
  }

  .footer-copy {
    width: 100%;
    height: 65px;
    border-top: 1px solid #8d8d8d;
  }

  .footer-copy-main {
    margin: auto;
    width: 1200px;
    background: #333;
    line-height: 65px;
    text-shadow: none;
    color: #d7d7d7;
    font-size: 10px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue